var GatedDocument = function(options) {
    this.options = {
        $el: false,
    };

    $.extend(true, this.options, options);

}

GatedDocument.prototype.init = function() {
    var downloadButton = document.getElementById('gated-document-download');
    if(downloadButton) {
        if (document.readyState === "loading") {
            window.location.hash = 'document';
            document.addEventListener("DOMContentLoaded", downloadButton.click());
        } else {
            window.location.hash = 'document';
            downloadButton.click();
        }
        
    }
}

export default GatedDocument;